
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/content_wall/templates/layout"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class='slide_contents'>\n  <header class='header'>\n    <div class='header_content'><div class='title'>Day View for "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"subject") : depth0)) != null ? lookupProperty(stack1,"scheduled_start_at") : stack1), depth0))
    + " - "
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"subject") : depth0)) != null ? lookupProperty(stack1,"scheduled_end_at") : stack1), depth0))
    + "</div><div class='sub_title'>"
    + alias2(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data,"loc":{"start":{"line":3,"column":154},"end":{"line":3,"column":163}}}) : helper)))
    + "</div></div>\n    <div class='timeline_region'></div>\n  </header>\n  <div class='moments_region'></div>\n</div>\n<div class='presentation_slide_bg'></div>\n";
},"useData":true});
    }).call(this);
  